import ChakraSidebar from './ChakraSidebar';

export default ChakraSidebar;